"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeFragment = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  fragment localeFragment on Locale {\n    zh_TW\n    en_US\n    ja_JP\n    vi_VN\n    fr_FR\n    es_ES\n    th_TH\n    id_ID\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// definition
var localeFragment = (0, _client.gql)(_templateObject());
exports.localeFragment = localeFragment;